<template>
  <v-main class="inline-layout">
    <editor-mode-toggle></editor-mode-toggle>

    <v-container fluid class="pa-0">
      <v-row no-gutters>
        <v-col>
          <inline-editor>
            <slot></slot>
          </inline-editor>
        </v-col>
      </v-row>
    </v-container>
  </v-main>
</template>

<script>
import '@/assets/scss/webble.frontend.scss'
import '@/assets/scss/webble.mobile.scss'
import EditorModeToggle from '@/components/editor/EditorModeToggle'
import InlineEditor from '@/components/editor/inline/InlineEditor'

export default {
  name: 'InlineLayout',
  components: {
    EditorModeToggle,
    InlineEditor
  }
}
</script>
